import styled, { css } from "styled-components";
import type { CheckboxVariantsType } from "./Checkbox";

// STYLES
const checkboxStyle = css`
    --_checkbox-width: var(--checkbox-width, 40px);
    --_checkbox-height: var(--checkbox-height, 40px);
    --_checkbox-border-radius: var(--checkbox-border-radius, 4px);
    --_checkbox-text-color: var(--checkbox-text-color, --color-primary-black);
    --_checkbox-bg-color: var(--checkbox-bg-color, --color-primary-white);
    --_checkbox-border-color: var(--checkbox-border-color, --color-grey-4);
    --_checkbox-hover-text-color: var(--checkbox-hover-text-color, --color-primary-black);
    --_checkbox-hover-bg-color: var(--checkbox-hover-bg-color, --color-primary-black);
    --_checkbox-hover-border-color: var(--checkbox-hover-border-color, --color-primary-black);
    --_checkbox-active-text-color: var(--checkbox-active-text-color, --color-primary-white);
    --_checkbox-active-bg-color: var(--checkbox-active-bg-color, --color-primary-black);
    --_checkbox-active-border-color: var(--checkbox-active-border-color, --color-primary-black);
    --_checkbox-disabled-text-color: var(--checkbox-disabled-text-color, --color-primary-black);
    --_checkbox-disabled-bg-color: var(--checkbox-disabled-bg-color, --color-primary-black);
    --_checkbox-disabled-border-color: var(--checkbox-disabled-border-color, --color-primary-black);
    position: relative;
    width: var(--_checkbox-width);
    height: var(--_checkbox-height);
    border-radius: var(--_checkbox-border-radius);

    label {
        display: flex;
        align-items: center;
        justify-content: center;
        width: var(--_checkbox-width);
        height: var(--_checkbox-height);
        margin: 0;
        color: var(--_checkbox-text-color);
        background-color: var(--_checkbox-bg-color);
        border: 1px solid var(--_checkbox-border-color);
        border-radius: var(--_checkbox-border-radius);
        cursor: pointer;
    }

    input[type="checkbox"] {
        position: absolute;
        white-space: nowrap;
        cursor: pointer;
        opacity: 0;
        overflow: hidden;
    }

    input[type="checkbox"]:checked ~ label {
        color: var(--_checkbox-active-text-color);
        background-color: var(--_checkbox-active-bg-color);
        border-color: var(--_checkbox-active-border-color);
    }

    input[disabled]:checked ~ label,
    input[disabled] ~ label {
        color: var(--_checkbox-disabled-text-color);
        background-color: var(--_checkbox-disabled-bg-color);
        border-color: var(--_checkbox-disabled-border-color);
        cursor: default;
    }

    label:hover,
    input[type="checkbox"]:hover + label {
        color: var(--_checkbox-hover-text-color);
        background-color: var(--_checkbox-hover-bg-color);
        border-color: var(--_checkbox-hover-border-color);
    }

    &:focus-within {
        label {
            color: var(--_checkbox-hover-text-color);
            background-color: var(--_checkbox-hover-bg-color);
            border-color: var(--_checkbox-hover-border-color);
        }
    }
`;

const favourite = css`
    --checkbox-width: 40px;
    --checkbox-height: 40px;
    --checkbox-border-radius: 50%;
    --checkbox-text-color: var(--color-primary-black);
    --checkbox-bg-color: var(--color-primary-white);
    --checkbox-border-color: var(--color-grey-4);
    --checkbox-hover-text-color: var(--color-highlight-black);
    --checkbox-hover-bg-color: var(--color-primary-white);
    --checkbox-hover-border-color: var(--color-highlight-black);
    --checkbox-active-text-color: var(--color-primary-white);
    --checkbox-active-bg-color: var(--color-primary-black);
    --checkbox-active-border-color: var(--color-primary-black);
    --checkbox-disabled-text-color: var(--color-primary-black);
    --checkbox-disabled-bg-color: var(--color-primary-white);
    --checkbox-disabled-border-color: var(--color-grey-4);
    ${checkboxStyle};
`;

const pack = css`
    --checkbox-width: 32px;
    --checkbox-height: 32px;
    --checkbox-border-radius: 4px;
    --checkbox-text-color: var(--color-primary-black);
    --checkbox-bg-color: var(--color-primary-white);
    --checkbox-border-color: var(--color-primary-black);
    --checkbox-hover-text-color: var(--color-primary-white);
    --checkbox-hover-bg-color: var(--color-primary-black);
    --checkbox-hover-border-color: var(--color-primary-black);
    --checkbox-active-text-color: var(--color-primary-white);
    --checkbox-active-bg-color: var(--color-primary-black);
    --checkbox-active-border-color: var(--color-primary-black);
    --checkbox-disabled-text-color: var(--color-primary-white);
    --checkbox-disabled-bg-color: var(--color-grey-6);
    --checkbox-disabled-border-color: var(--color-grey-6);
    ${checkboxStyle};
`;

// COMPONENTS
export const CheckboxVariants = {
    favourite,
    pack,
};

const CheckboxVariant = styled.div<{ variant: CheckboxVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${CheckboxVariants[variant]};
        `};
`;

export default CheckboxVariant;
